import React from 'react';

const OrderCustomizationPhotos = ({ images = [] }) => {
  if (!Array.isArray(images) || images.length === 0) {
    return null;
  }

  return (
    <div className="mt-3 flex flex-wrap gap-2">
      {images.map((image, index) => (
        <a
          key={`${image}-${index}`}
          href={image}
          target="_blank"
          rel="noreferrer"
          aria-label={`Open reference photo ${index + 1}`}
          className="block h-16 w-16 overflow-hidden rounded-lg border border-slate-200"
        >
          <img
            src={image}
            alt={`Customization reference ${index + 1}`}
            loading="lazy"
            className="h-full w-full object-cover"
          />
        </a>
      ))}
    </div>
  );
};

export default OrderCustomizationPhotos;
